import type { Medication } from './types';
import { ProductFormulations } from './types';

export const deriveMaxAllowedQuantity = (availableProduct: Medication) => {
  if (availableProduct.formulation === ProductFormulations.DEVICE) {
    return 10;
  }

  const remainingUnits = Math.max(availableProduct.quantity ?? 0, 0);

  return Math.min(remainingUnits, availableProduct.quantity ?? 0);
};
